"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

exports.styles = function (_a) {
  var colorPrimary = _a.colorPrimary,
      colorSecondary = _a.colorSecondary;
  return {
    base: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      '&:before, &:after': {
        content: '""',
        width: '25%',
        height: '25%',
        willChange: 'transform, opacity',
        borderRadius: '50%',
        backgroundColor: colorPrimary.normal
      },
      '&:before': {
        position: 'absolute',
        animation: 'pulse-dot-1 1s',
        animationIterationCount: function animationIterationCount(props) {
          return props.iterationsCount || 'infinite';
        }
      },
      '&:after': {
        animation: 'pulse-dot-2 1s',
        animationIterationCount: function animationIterationCount(props) {
          return props.iterationsCount || 'infinite';
        }
      }
    },
    secondary: {
      '&:before, &:after': {
        backgroundColor: colorSecondary.normal
      }
    },
    fixed: {
      '&:before, &:after': {
        animation: 'none'
      }
    },
    '@keyframes pulse-dot-1': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(1.1)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    },
    '@keyframes pulse-dot-2': {
      '0%': {
        transform: 'scale(1)',
        opacity: 1
      },
      '100%': {
        transform: 'scale(4)',
        opacity: '0'
      }
    }
  };
};